import { Component, Prop } from 'vue-property-decorator';
import Vue, { PropType } from 'vue';
import { IssueEntity } from '@/entities/issue.entity';
import { mapGetters } from 'vuex';
import { StaffEntity } from '@/entities/staff.entity';

@Component<IssueItemBaseMixin>({
  computed: {
    ...mapGetters('staff', ['currentStaff']),
  },
})
export default class IssueItemBaseMixin extends Vue {
  currentStaff!: StaffEntity;

  @Prop({ type: Object as PropType<IssueEntity>, required: true })
  issue: IssueEntity;
}
